import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { listhomework, studentview, stusubjectlist, stuacademicyearlist, teacherview } from "../service/dashboard";
import moment from "moment";

const Homework = () => {
    const [subject, setSubject] = useState("");
    const [sublist, setSubList] = useState([]);

    const [hwlist, setHWList] = useState([]);
    const [hwpath, setHWPath] = useState("");

    const [ayear, setAYear] = useState("");
    const [aylist, setAYList] = useState([]);

    const [fromDate, setFromDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

    useEffect(() => {
        const today = moment(new Date()).format("YYYY-MM-DD");
        stusubjectlist().then((res) => {
            if (res.status === true) {
                setSubList(res.data);
            }
        });

        const temp = new FormData();
        temp.append("academy_id", localStorage.getItem("academy"));
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true && res.data.length > 0) {
                const sorted = [...res.data].sort((a, b) => Number(b.id) - Number(a.id));
                setAYList(sorted);
                const latest = sorted[0].id;
                setAYear(latest);
                listall('', latest, today, today);
            }
        });
    }, []);
    function listall(sub, year, hte, dte) {
        setHWList([]);
        setAYear(year);
        setFromDate(hte);
        setToDate(dte);
        if (localStorage.getItem("Role") === "4") {
            studentview(localStorage.getItem("UID")).then((res1) => {
                if (res1.status === true) {
                    const temp = new FormData();
                    temp.append("academy", res1.data.details.academy_id);
                    temp.append("academic_year", year);
                    temp.append("class_id", res1.data.details.class_id);
                    temp.append("section", res1.data.details.section_id);
                    temp.append("subject", sub);
                    temp.append("due_date", dte);
                    temp.append("from_date", hte);

                    listhomework(temp).then((res) => {
                        if (res.status === true) {
                            setHWPath(res.data.path);
                            if (res.data.details.length > 0) {
                                const hdata = res.data.details.map(item => {
                                    return {
                                        ...item,
                                        due_date: moment(item.due_date).format("DD-MM-YYYY"),
                                    }
                                })
                                setHWList(hdata);
                            }
                        }
                    });
                }
            });
        }else if(localStorage.getItem("Role") === "5") {
             teacherview(localStorage.getItem("UID")).then((res1) => {
            if (res1.status === true) {
                const temp = new FormData();
                temp.append("academy", "");
                temp.append("academic_year", year);
                temp.append("class_id", "");
                temp.append("section","");
                temp.append("subject", sub);
                temp.append("due_date", dte);
                temp.append("from_date", hte);

                listhomework(temp).then((res) => {
                    if (res.status === true) {
                        setHWPath(res.data.path);
                        if (res.data.details.length > 0) {
                            const hdata = res.data.details.map(item => {
                                return {
                                    ...item,
                                    due_date: moment(item.due_date).format("DD-MM-YYYY"),
                                }
                            })
                            setHWList(hdata);
                        }
                    }
                });
            }
        });
        }



    }


    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={4} className="text-left align-self-end">
                            <h4 className="morehead-text">HomeWork</h4>
                        </Col>
                        {localStorage.getItem("Role") == "5" ? <Col xs={4} className="text-center align-self-end">
                            <Link to={"/addhomework"} className="btn-outline-success green-btn btn-sm">
                                <i className="fa fa-plus-square"></i> Add
                            </Link>
                        </Col> : <Col xs={4} className="text-center align-self-end"></Col>}
                        <Col xs={4} className="text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>


                {/* Filters */}
                <div className="p-3">
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Label>Academic Year</Form.Label>
                            <Form.Select
                                value={ayear}
                                onChange={(e) => {
                                    setAYear(e.target.value);
                                    listall(subject, e.target.value, fromDate, toDate);
                                }}
                            >
                                <option value="" disabled>
                                    {" "}
                                    Select Academic Year
                                </option>
                                {aylist.map((yr) => (
                                    <option key={yr.id} value={yr.id}>
                                        {yr.aca_year}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label>From Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={fromDate}
                                onChange={(e) => listall(subject, ayear, e.target.value, toDate)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>To Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={toDate}
                                onChange={(e) => listall(subject, ayear, fromDate, e.target.value)}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Label>Subject</Form.Label>
                            <Form.Select
                                value={subject}
                                onChange={(e) => {
                                    setSubject(e.target.value);
                                    listall(e.target.value, ayear, fromDate, toDate);
                                }}
                            >
                                <option value="" disabled>
                                    {" "}
                                    Select Subject
                                </option>
                                {sublist.map((subj, idx) => (
                                    <option key={idx} value={subj.id}>
                                        {subj.subject_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                </div>

                {/* <h6 className="text-center text-muted mb-3">Filtered Homework</h6> */}

                {hwlist.length == 0 ? (
                    <p className="text-center text-danger fw-bold">No homework found.</p>
                ) : (
                    hwlist.map((item, index) => (
                        <div className="row align-items-stretch mb-3 px-3" key={index}>
                            <div className="col-2 d-flex justify-content-center position-relative">
                                <div className="timeline-line"></div>
                                <div className="hour-circle text-white fw-bold">{index + 1}</div>
                            </div>
                            <div className="col-10 rounded-3 p-3 bg-primary-subject text-white">
                                <div>Subject: {item.subject_name}</div>
                                <div>Staff: {item.teacher_name}</div>
                                {item.description && (
                                    <div className="mt-2">
                                        <strong>Homework:</strong> {item.description}
                                    </div>
                                )}
                                {item.work_file && (
                                    <div className="mt-2">
                                        <strong>Attachment:</strong>{" "}
                                        <a
                                            href={hwpath + item.work_file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-white text-decoration-underline"
                                        >
                                            {item.work_file.split(".").pop() === "pdf" ? "View PDF" : "View File"}
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
            <Footer />
        </div>
    );
};

export default Homework;
